import maryPic from "@/public/images/artists/mary.jpg";
import { Artist } from "@/types/types";

export const mary = {
  id: "110",
  name: "Mary",
  image: maryPic,
  description: `Mary's deep and earthy voice resonates with raw emotion and attitude, perfectly tailored to funk music. It exudes confidence and charisma, leaving a lasting impression with its powerful delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmary-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Soul", "Funk", "Disco", "Deep"],
      secondary: ["Singer", "Wide Range", "Attitude"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 51,
        high: 68,
      },
    },
  },
} as const satisfies Artist;
